import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FileDownloadService } from '@services/file-download.service';
import { FilenameParser } from '@utils/FilenameParser';
import moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { exhaustMap, retry, take } from 'rxjs/operators';
import { LocalStorageDecorator } from 'src/app/libs/local-storage-decorator';
import { ListarPedidosService } from 'src/app/services/listar-pedidos.service';
import { UsuarioPermissaoService } from 'src/app/services/usuario-permissao.service';
import { GerarPlanilhaDadosService } from '@services/gerar-planilha-dados.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { AlertErroCustomizadoComponent } from '../../components/alert-erro-customizado/alert-erro-customizado.component';
import { FormsModule } from '@angular/forms';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatSuffix } from '@angular/material/form-field';
import { FieldErrorComponent } from '../../components/field-error/field-error.component';
import { SelectComponent } from '../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-listar-pedidos',
    templateUrl: './listar-pedidos.component.html',
    styleUrls: ['./listar-pedidos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, LoadingGenericoComponent, AlertErroCustomizadoComponent, FormsModule, BreadcrumbComponent, DateMaskDirective, MatDatepickerInput, NgClass, MatDatepickerToggle, MatSuffix, MatDatepicker, FieldErrorComponent, RouterLink, SelectComponent, NgxPaginationModule, FooterComponent, AsyncPipe, CamelCasePipe, CnpjPipe, UsuarioPermissaoPipe, AppDatePipe]
})
export class ListarPedidosComponent implements OnInit, OnDestroy {
  public empresas: any = null;
  public empresasPorPagina = 5;
  public totalEmpresas = null;
  public paginaEmpresa = 1;
  public idEmpresaLogada: string;
  public numeroPedidoInput: string;
  public numeroPedidoVazio = false;

  LoadingGenericoMessage: string;
  public LoadingGenerico = false;

  public dataFinalError = false;
  public dataFinalMessageError = 'Data Final Inválida';
  public dataInicialError = false;
  public dataInicialMessageError = 'Data Inicial Inválida';
  public dataAtual: any;

  public empresasFiltradas: any = null;
  public dadosFiltrados = false;
  public dataInicial: any;
  public dataInicialVazia = false;
  public dataFinal: any;
  public dataFinalVazia = false;

  public empresaSemRegistrosError = false;

  // PAGINAÇÃO DAS EMPRESAS FILTRADA
  public empresasFiltradasPorPagina = 5;
  public paginaEmpresaFiltrada = 1;

  public botaoBeneficioRepetido: string;
  public mensagemBeneficioRepetido: string;
  public tituloMensagemBeneficioRepetido: any;
  public beneficioRepetido: boolean = false;

  falhaPesquisa = false;

  mensagemErroSubtitulo = 'Erro ao gerar arquivo .';
  mensagemErro =
    'Ocorreu um erro ao gerar o arquivo, por favor, tente novamente.';

  subscriptions = new Subscription();
  @LocalStorageDecorator()
  fileNamePending: string;
  @LocalStorageDecorator('listar-pedido-download-pendente')
  hasPendingFileExport: boolean;
  @LocalStorageDecorator() idDownload: string;
  idEmpresaDetalhePedido: number;
  temBoleto: any;

  constructor(
    private readonly service: ListarPedidosService,
    public readonly router: Router,
    private readonly gerarPlanilhaDadosService: GerarPlanilhaDadosService,
    public usuarioPermissaoService: UsuarioPermissaoService
  ) {}

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    this.getAllCnpjs();
    if (this.hasPendingFileExport) {
      this.watchFileGenerationStatus();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getAllCnpjs() {

    this.dadosFiltrados = false;
    this.service
      .getAllCnpjs(
        this.idEmpresaLogada,
        this.paginaEmpresa,
        this.empresasPorPagina
      )
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.empresas = response?.response?.content;
          this.totalEmpresas = response?.response?.totalElements;
          this.temBoleto = !!this.empresas.find((empresa) => empresa.isBoleto === true);
        } else {
          this.empresas = false;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.empresas = false;
      }
    });
  }

  onPageChange(pageNumber: number) {

    this.paginaEmpresa = pageNumber;
    if(this.dadosFiltrados) {
      this.getCnpjFiltrados();
    } else {
      this.getAllCnpjs();
    }
  }

  onPageSizeChange(pageSize: number) {

    this.empresasPorPagina = pageSize;
    if(this.dadosFiltrados) {
      this.getCnpjFiltrados();
    } else {
      this.getAllCnpjs();
    }
  }

  abreFechaEmpresa(empresa) {
    const flechaResolucao = document.querySelector('#flechaResolucao' + empresa.idEmpresa);
    const colunaResolucao = document.querySelector('#colunaResolucao' + empresa.idEmpresa);

    if (flechaResolucao.classList.contains('fa-chevron-right')) {
      // QUANDO ABRE
      flechaResolucao.classList.remove('fa-chevron-right');
      flechaResolucao.classList.add('fa-chevron-down');
      colunaResolucao.classList.remove('d-none');

      // CONSULTA DOS PEDIDOS DA EMPRESA ESPECIFICA (função para retornar todos os pedidos);

      if (!empresa.pedidos) {
        this.getAllPedidos(empresa);
      }
    } else {
      flechaResolucao.classList.remove('fa-chevron-down');
      flechaResolucao.classList.add('fa-chevron-right');
      colunaResolucao.classList.add('d-none');
    }
  }

  getAllPedidos(empresa) {

    empresa.carregandoPedidos = true;
    let dataInicialFormatada = null;
    let dataFinalFormatada = null;

    if(this.dataInicial && this.dataFinal){
      dataInicialFormatada = `${this.dataInicial.getFullYear()}-${String(this.dataInicial.getMonth()+1).padStart(2,'0')}-${String(this.dataInicial.getDate()).padStart(2,'0')}`;
      dataFinalFormatada = `${this.dataFinal.getFullYear()}-${String(this.dataFinal.getMonth()+1).padStart(2,'0')}-${String(this.dataFinal.getDate()).padStart(2,'0')}`;
    }
    this.service
      .getAllPedidos(empresa.idEmpresa, dataInicialFormatada, dataFinalFormatada)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            empresa.pedidos = response.response;
          } else {
            empresa.pedidos = [];
          }
          empresa.carregandoPedidos = false;
        },
        error: (erro: any) => {
          console.error(erro);
          empresa.pedidos = [];
        }
      });
  }

  detalharPedido(idPedido: number, idEmpresa: number) {
    this.idEmpresaDetalhePedido = idEmpresa;
    this.router.navigate(['listar-pedidos-detalhes'], {
      queryParams: { idPedido, idEmpresa },
    });
  }

  buscarNumeroPedido() {
    if (this.numeroPedidoInput) {
      this.service
        .getResumoPedido(this.numeroPedidoInput, this.idEmpresaLogada)
        .pipe(take(1))
        .subscribe((response: any) => {
          if (response.status == 'OK') {
            this.numeroPedidoVazio = false;
            this.router.navigate(['listar-pedidos-detalhes'], {
              queryParams: {
                idPedido: this.numeroPedidoInput,
                idEmpresa: this.idEmpresaLogada,
              },
            });
          } else {
            this.beneficioRepetido = true;
            this.tituloMensagemBeneficioRepetido = '';
            this.mensagemBeneficioRepetido = 'Pedido não encontrado.';
            this.botaoBeneficioRepetido = 'Fechar';
          }
        });
    } else {
      this.numeroPedidoVazio = true;
    }
  }

  // QUANDO CLICA EM BAIXAR RELATÓRIO

  public baixarBoletoPedido(idPedido: string) {
    this.service
      .baixarBoletoPedido(idPedido)
      .pipe(take(1))
      .subscribe({
        next: ({body, headers}: HttpResponse<any>) => {
          const filename = FilenameParser.fromContentDispositionHeader(
            headers.get('content-disposition'),
            'boleto-pedido.pdf'
          );
          FileDownloadService.download([body], filename);
        },
        error: (error: any) => {
          this.beneficioRepetido = true;

          if (error?.status === 404) {
            this.tituloMensagemBeneficioRepetido = 'TÍTULO INDISPONÍVEL';
            this.mensagemBeneficioRepetido =
              'Não foi possível localizar o boleto para o pedido informado.';
          } else {
            this.tituloMensagemBeneficioRepetido = 'ERRO AO GERAR BOLETO';
            this.mensagemBeneficioRepetido =
              'Ocorreu um erro ao gerar o boleto. Por favor, tente novamente.';
          }

          this.botaoBeneficioRepetido = 'Fechar';
        }
      });
  }

  startFileGeneration() {
    this.LoadingGenerico = true;
    this.service
      .startFileGeneration(this.idEmpresaLogada)
      .subscribe(({ response }) => {
        this.LoadingGenericoMessage =
          'Por favor, aguarde enquanto seu arquivo é gerado...';
        this.hasPendingFileExport = true;
        this.idDownload = response.idDownload;
        this.watchFileGenerationStatus();
      });
  }

  private watchFileGenerationStatus() {
    this.LoadingGenerico = true;

    const subscription = interval(1000)
      .pipe(
        exhaustMap(() =>
          this.gerarPlanilhaDadosService
            .getFileGenerationStatus(this.idDownload, 'pdf')
            .pipe(retry())
        )
      )
      .subscribe(({ response }) => {
        this.LoadingGenerico = true;
        if (!response?.status || response?.status === 'ERRO') {
          this.hasPendingFileExport = undefined;
          this.LoadingGenericoMessage = null;
          this.falhaPesquisa = true;
          this.LoadingGenerico = false;
          this.idDownload = undefined;
          subscription.unsubscribe();
        } else if (response?.status === 'FINALIZADO') {
          this.fileNamePending = response?.nomeArquivo;
          this.LoadingGenericoMessage = null;
          this.LoadingGenerico = false;
          this.hasPendingFileExport = undefined;
          window.open(response?.urlDownload);
          this.idDownload = undefined;
          subscription.unsubscribe();
        } else {
          this.LoadingGenericoMessage =
            'Por favor, aguarde enquanto seu arquivo é gerado...';
        }
      });
    this.subscriptions.add(subscription);
  }

  filtrarData() {
    if (!this.dadosFiltrados) {
      this.paginaEmpresa = 1;
      this.totalEmpresas = 0;
    }
    this.dadosFiltrados = true;
    this.empresas = undefined;

    this.dataInicialVazia = !this.dataInicial;
    this.dataFinalVazia = !this.dataFinal;

    this.onDataInicialPedido();
    this.onDataFinalPedido();
    this.dataHoje();

    if (this.dataInicialError || this.dataFinalError) {
      this.empresas = [];
      return;
    }

    if (this.dataInicial && this.dataFinal) {
      this.getCnpjFiltrados();
    }
  }

  getCnpjFiltrados() {

    const dataInicialFormatada = `${this.dataInicial.getFullYear()}-${String(this.dataInicial.getMonth()+1).padStart(2,'0')}-${String(this.dataInicial.getDate()).padStart(2,'0')}`;
    const dataFinalFormatada = `${this.dataFinal.getFullYear()}-${String(this.dataFinal.getMonth()+1).padStart(2,'0')}-${String(this.dataFinal.getDate()).padStart(2,'0')}`;

    this.service
      .getAllCnpjsFiltrado(dataInicialFormatada, dataFinalFormatada, this.idEmpresaLogada, this.paginaEmpresa, this.empresasPorPagina)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.empresas = response?.response?.content;
          this.totalEmpresas = response?.response?.totalElements;

          if (this.totalEmpresas === 0) {
            this.empresaSemRegistrosError = true;
          }else {
            this.empresaSemRegistrosError = false;
          }   
        },
        error: (erro: any) => {
          console.error(erro);
        }
      });
  }

  limparFiltro() {
    this.dataInicial = '';
    this.dataInicialVazia = false;
    this.dataFinal = '';
    this.dataFinalVazia = false;
    this.dataFinalError = false;
    this.dataInicialError = false;
    this.dadosFiltrados = false;
    this.empresaSemRegistrosError = false;
    
    this.getAllCnpjs();
  }

  onDataInicialPedido() {
    if (!this.dataInicial) {
      this.dataInicialError = true;
      this.dataInicialMessageError = '';
    } else if (this.dataFinal) {
      if (moment(this.dataInicial) > moment(this.dataFinal)) {
        this.dataInicialError = true;
        this.dataInicialMessageError = 'Data Inicial Maior que Data Final';
      } else {
        this.dataInicialError = false;
        this.dataInicialMessageError = 'Data Inicial Inválida';
      }
    } else {
      this.dataInicialError = false;
      this.dataInicialMessageError = 'Data Inicial Inválida';
    }
  }

  onDataFinalPedido() {
    if (!this.dataFinal) {
      this.dataFinalError = true;
      this.dataFinalMessageError = '';
    } else if (this.dataInicial) {
      if (moment(this.dataInicial) > moment(this.dataFinal)) {
        this.dataFinalError = true;
        this.dataFinalMessageError = 'Data Final Menor que Data Inicial';
      } else {
        this.dataFinalError = false;
        this.dataFinalMessageError = 'Data Final Inválida';
      }
    } else {
      this.dataFinalError = false;
      this.dataFinalMessageError = 'Data Final Inválida';
    }
  }

  dataHoje() {
    const data = new Date();
    const dia = data.getDate();
    const mes = data.getMonth() + 1;
    const ano = data.getFullYear();

    this.dataAtual = ano + '-' + mes + '-' + dia;
    if (this.dataInicial && moment(this.dataInicial).startOf('day') > moment(this.dataAtual)) {
      this.dataInicialError = true;
      this.dataInicialMessageError = 'Data Inicial Inválida';
    }

    if (this.dataFinal && moment(this.dataFinal).startOf('day') > moment(this.dataAtual)) {
      this.dataFinalError = true;
      this.dataFinalMessageError = 'Data Final Maior que hoje';
    }
  }

  fecharAlertErro() {
    this.falhaPesquisa = false;
  }

  public fecharAlertPedidoErro() {
    this.beneficioRepetido = false;
  }

  public onEmpresasPorPaginaChange(value: number) {
    this.empresasPorPagina = value;
    this.paginaEmpresa = 1;
  }
}
